<template>
  <div>
    <div>
      <el-tag
        v-show="!disabled"
        style="margin-right: 10px;"
        v-for="(item, i) in time"
        :key="item"
        closable
        size="medium"
        @close="handleClose(item, i)"
      >
        {{ item.time }}
      </el-tag>
      <el-tag
        v-show="disabled"
        size="medium"
        style="margin-right: 10px;"
        v-for="item in time"
        :key="item"
      >
        {{ item.time }}
      </el-tag>

      <div class="add">
        <el-popover class="box-card" v-model="show">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="box">
              <div class="select">
                <div style="text-align: center;">
                  <h3>开始时间</h3>
                  <el-form-item prop="startTime">
                    <el-select
                      v-model="ruleForm.startTime"
                      @change="getEndOption"
                      placeholder="请选择开始时间"
                    >
                      <el-option
                        style="text-aline: center;"
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div style="margin-left: 30px; text-align: center;">
                  <h3>结束时间</h3>
                  <el-form-item prop="endTime">
                    <el-select
                      v-model="ruleForm.endTime"
                      @change="$forceUpdate()"
                      no-data-text="请先选择开始时间"
                      placeholder="请选择结束时间"
                    >
                      <el-option
                        v-for="item in endOptions"
                        :key="item.value + 25"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div style="margin-left: 30px; text-align: center;">
                  <h3>天数</h3>
                  <el-form-item prop="days">
                    <el-input v-model="ruleForm.days" maxlength="3"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="button">
                <el-button type="primary" @click="addTime('ruleForm')">确定</el-button>
                <el-button type="info" @click="show = false">取消</el-button>
              </div>
            </div>
          </el-form>
          <el-tag slot="reference" type="danger" size="medium" v-show="!disabled">+</el-tag>
        </el-popover>
      </div>
      <div v-show="!disabled" style="margin-top: 10px;">
        <!-- <span class="el-icon-warning" style="color: #e6a23c;"></span> 该班组巡检计划已存在时间段 -->
      </div>
      <!-- <div v-show="!disabled">
        <el-tag
          type="info"
          effect="dark"
          size="medium"
          style="margin-right: 10px;"
          v-for="item in selectedTime"
          :key="item"
        >
          {{ item.timeQuantum }}
        </el-tag>
      </div> -->
    </div>
  </div>
</template>

<script>
let dictTime = [
  {
    label: '0点',
    value: 0,
    disabled: false,
  },
  {
    label: '1点',
    value: 1,
    disabled: false,
  },
  {
    label: '2点',
    value: 2,
    disabled: false,
  },
  {
    label: '3点',
    value: 3,
    disabled: false,
  },
  {
    label: '4点',
    value: 4,
    disabled: false,
  },
  {
    label: '5点',
    value: 5,
    disabled: false,
  },
  {
    label: '6点',
    value: 6,
    disabled: false,
  },
  {
    label: '7点',
    value: 7,
    disabled: false,
  },
  {
    label: '8点',
    value: 8,
    disabled: false,
  },
  {
    label: '9点',
    value: 9,
    disabled: false,
  },
  {
    label: '10点',
    value: 10,
    disabled: false,
  },
  {
    label: '11点',
    value: 11,
    disabled: false,
  },
  {
    label: '12点',
    value: 12,
    disabled: false,
  },
  {
    label: '13点',
    value: 13,
    disabled: false,
  },
  {
    label: '14点',
    value: 14,
    disabled: false,
  },
  {
    label: '15点',
    value: 15,
    disabled: false,
  },
  {
    label: '16点',
    value: 16,
    disabled: false,
  },
  {
    label: '17点',
    value: 17,
    disabled: false,
  },
  {
    label: '18点',
    value: 18,
    disabled: false,
  },
  {
    label: '19点',
    value: 19,
    disabled: false,
  },
  {
    label: '20点',
    value: 20,
    disabled: false,
  },
  {
    label: '21点',
    value: 21,
    disabled: false,
  },
  {
    label: '22点',
    value: 22,
    disabled: false,
  },
  {
    label: '23点',
    value: 23,
    disabled: false,
  },
  {
    label: '24点',
    value: 24,
    disabled: false,
  },
];
let id = 1;
export default {
  name: 'selectTime',
  props: ['disabled', 'quantumTime', 'selectedTime', 'groupId'],
  data() {
    
      var validatePass = (rule, value, callback) => {
        
              let re = /^[0-9]+$/ ;
        if (value === '') {
          callback(new Error('请填写天数!'));
        } else if (!re.test(value)) {
          callback(new Error('天数格式错误!'));
        } else {
          callback();
        }
      };
    return {
      ruleForm: {
        startTime: '',
        endTime: '',
        days:''
      },
      show: true,
dictTime:[
  {
    label: '0点',
    value: 0,
    disabled: false,
  },
  {
    label: '1点',
    value: 1,
    disabled: false,
  },
  {
    label: '2点',
    value: 2,
    disabled: false,
  },
  {
    label: '3点',
    value: 3,
    disabled: false,
  },
  {
    label: '4点',
    value: 4,
    disabled: false,
  },
  {
    label: '5点',
    value: 5,
    disabled: false,
  },
  {
    label: '6点',
    value: 6,
    disabled: false,
  },
  {
    label: '7点',
    value: 7,
    disabled: false,
  },
  {
    label: '8点',
    value: 8,
    disabled: false,
  },
  {
    label: '9点',
    value: 9,
    disabled: false,
  },
  {
    label: '10点',
    value: 10,
    disabled: false,
  },
  {
    label: '11点',
    value: 11,
    disabled: false,
  },
  {
    label: '12点',
    value: 12,
    disabled: false,
  },
  {
    label: '13点',
    value: 13,
    disabled: false,
  },
  {
    label: '14点',
    value: 14,
    disabled: false,
  },
  {
    label: '15点',
    value: 15,
    disabled: false,
  },
  {
    label: '16点',
    value: 16,
    disabled: false,
  },
  {
    label: '17点',
    value: 17,
    disabled: false,
  },
  {
    label: '18点',
    value: 18,
    disabled: false,
  },
  {
    label: '19点',
    value: 19,
    disabled: false,
  },
  {
    label: '20点',
    value: 20,
    disabled: false,
  },
  {
    label: '21点',
    value: 21,
    disabled: false,
  },
  {
    label: '22点',
    value: 22,
    disabled: false,
  },
  {
    label: '23点',
    value: 23,
    disabled: false,
  },
  {
    label: '24点',
    value: 24,
    disabled: false,
  },
],
      time: [],
      // options: this.dictTime,
      options: '',
      endOptions: [],
      rules: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        days: [{ required: true, validator: validatePass, trigger: 'blur' }],
      },
    };
  },
  created() {
    console.log(this.dictTime);
    this.options = this.dictTime;
    if (!this.quantumTime) {
      return;
    }
    let container = [];
    for (var i = 0; i < this.quantumTime.length; i++) {
      var obj = {};
      obj.time = this.quantumTime[i].start + '~' + this.quantumTime[i].end + '+' + this.quantumTime[i].days;
      var startTime = this.quantumTime[i].start.slice(0, 2);
      var endTime = this.quantumTime[i].end.slice(0, 2);
      obj.startTime = Number(startTime);
      obj.endTime = Number(endTime);
      for (var j = obj.startTime; j < obj.endTime; j++) {
        this.dictTime[j].disabled = true;
      }
      container.push(obj);
    }
    this.time = container;
  },

  watch: {
    quantumTime() {
      let container = [];
      for (var i = 0; i < this.quantumTime.length; i++) {
        var obj = {};
        obj.time = this.quantumTime[i].start + '~' + this.quantumTime[i].end + '+' + this.quantumTime[i].days;
        var startTime = this.quantumTime[i].start.slice(0, 2);
        var endTime = this.quantumTime[i].end.slice(0, 2);
        obj.startTime = Number(startTime);
        obj.endTime = Number(endTime);
        for (var j = obj.startTime; j < obj.endTime; j++) {
          this.dictTime[j].disabled = true;
        }
        container.push(obj);
      }
      this.time = container;
    },
    selectedTime() {
      for (var i = 0; i < this.selectedTime.length; i++) {
        for (var j = this.selectedTime[i].beginTime; j < this.selectedTime[i].endTime; j++) {
          this.dictTime[j].disabled = true;
        }
      }
    },
  },
  methods: {
    // 重置数据
    reset() {
      setTimeout(() => {
        this.time = [];
      }, 0);
      for (var i = 0; i < this.dictTime.length; i++) {
        this.dictTime[i].disabled = false;
      }
    },
    //   删除添加的时间
    handleClose(tag, index) {
      this.time.splice(index, 1);
      this.selectedTime.forEach((item, index, arr) => {
        if (item.beginTime == tag.startTime) {
          this.selectedTime.splice(index, 1);
        }
      });

      for (var i = tag.startTime; i < tag.endTime; i++) {
        this.dictTime[i].disabled = false;
      }
      
      this.byValue();
    },
    //   添加时间段
    addTime(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.processTime();
          for (var i = Number(this.ruleForm.startTime); i < Number(this.ruleForm.endTime); i++) {
            this.dictTime[i].disabled = true;
          }
          this.ruleForm.startTime = '';
          this.ruleForm.endTime = '';
          this.ruleForm.days = '';
          this.show = false;
          // var time = "";
          // for(var i = 0;i<this.time.length;i++){
          //   time += this.time[i].time
          // }
          this.byValue();
        } else {
          return false;
        }
      });
    },
    byValue() {
      this.$emit('getTime', this.time);
    },
    processTime() {
      var obj = {};
      obj.time =
        this.formatting(this.ruleForm.startTime) + '~' + this.formatting(this.ruleForm.endTime) + '+' + this.ruleForm.days;
      obj.startTime = Number(this.ruleForm.startTime);
      obj.endTime = Number(this.ruleForm.endTime);
          obj.days = Number(this.ruleForm.days);
      this.time.push(obj);
    },
    formatting(time) {
      if (time < 10) {
        time = '0' + time;
      }
      return time + ':00';
    },
    //   获取结束时间下拉框数据
    getEndOption(node) {
      const nodes = [];
      node += 1;
      for (var i = node; i <= 24; i++) {
        nodes[i] = {};
        nodes[i].label = `${i}点`;
        nodes[i].value = i;
        nodes[i].disabled = false;
        nodes[i].level = false;
        if (this.dictTime[i].disabled == true) {
          break;
        }
      }
      this.endOptions = nodes.splice(node);
    },
    selectRoom2(item) {
      this.$emit('select', item);
    },
  },
};
</script>

<style scoped>
.box {
  width: 350px;
  margin: 0 15px;
  height: auto;
  /* padding: 20px; */
}
.add {
  position: relative;
  display: inline-block;
}
.select {
  display: flex;
  justify-content: space-between;
}
.button {
  text-align: right;
  margin-top: 30px;
}
</style>
